import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableEmptyStateComponent } from '@shared-modules/table-shared/_components';
import { AppRoutes } from '@shared/helpers';
import { initializeDashboardOrderTableColumns } from '../../_core/helpers';
import { DashboardService } from '../../_core/services/dashboard.service';
import { MyOrdersTableRowComponent } from './my-orders-table-row/my-orders-table-row.component';

@Component({
    selector: 'app-my-orders-table',
    standalone: true,
    imports: [TranslateModule, MyOrdersTableRowComponent, TableEmptyStateComponent, NgTemplateOutlet],
    templateUrl: './my-orders-table.component.html',
    styleUrls: ['./my-orders-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyOrdersTableComponent {
    readonly orderList = computed(() => this.dashboardService.dashboardData().ordersData.recentOrders);
    readonly orderSetupRoute = computed(() => AppRoutes.routes().ORDERS_SETUP);

    readonly columns = initializeDashboardOrderTableColumns();

    constructor(private dashboardService: DashboardService) {}
}
